import { render, staticRenderFns } from "./create-buyCardRecord.vue?vue&type=template&id=424066c2&scoped=true&"
import script from "./create-buyCardRecord.vue?vue&type=script&lang=ts&"
export * from "./create-buyCardRecord.vue?vue&type=script&lang=ts&"
import style0 from "./create-buyCardRecord.vue?vue&type=style&index=0&id=424066c2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "424066c2",
  null
  
)

component.options.__file = "create-buyCardRecord.vue"
export default component.exports